import "./FieldSettings.scss";
import fields from "./constants";
import burgerActive from "../../../../assets/images/dialog/settings/burgerActive.svg";
import burgerDisablee from "../../../../assets/images/dialog/settings/burgerDisabled.svg";
import { useState } from "react";
import classNames from "classnames";

export default function FieldSettings() {
  const [isSettingsModified, setSettingsModified] = useState(false);

  return (
    <div className="fields-settings-container">
      <div className="field-content-container">
        <div className="field-content-table">
          <div className="table-header-row">
            <div><p>System Field Names</p></div>
            <div><p>Custom Field Names</p></div>
            <div><p></p></div>
          </div>
          <div className="table-content-column">
            {fields?.map((fieldName: any) => (
              <div className="content-column-row" key={fieldName}>
                <div className="content-row-div">
                  <img src={burgerActive} />
                  <p className="field-name">{fieldName}</p>
                </div>
                <div className="content-row-div">
                  <input type="text" className="row-input"></input>
                </div>
                <div className="content-row-div">
                  <button className="">Reset</button>
                  <button className="">Hide</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="bottom-container">
        {/* <div className="gs-reset-holder">
         <p>Reset All Settings to Default Values</p> 
          <button
            className="settings-button-reset"
            //   onClick={handleResetToDefault}
          >
            Reset
          </button>
        </div> */}
        <div></div>
        <div className="gs-button-container">
          {isSettingsModified && (
            <button
              disabled={!isSettingsModified}
              className={classNames("settings-button", {
                "button-oranges": isSettingsModified,
              })}
              //   onClick={handleApply}
            >
              Apply
            </button>
          )}
          {!isSettingsModified && (
            <button
              className="settings-button"
              //    onClick={'handleClose'}
            >
              Close
            </button>
          )}
          {isSettingsModified && (
            <button
              className="settings-button"
              //   onClick={handleCancel}
            >
              Cancel
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
